export default "__VITE_ASSET__jVF3o9V5__$_?format=webp__"